import { BootstrapModule } from './bootstrap.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IconsModule } from './feather-icons.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { ALL_TAIGA_UI_MODULES } from './common_imports/all-taiga-modules';
import { FeatherModule } from 'angular-feather';
import { Facebook, Gitlab, Key, Twitter, Github, User, UserCheck, Mail } from 'angular-feather/icons';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { ToastrModule } from 'ngx-toastr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgbModule, NgbPopoverModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxGaugeModule } from 'ngx-gauge';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxEchartsModule } from 'ngx-echarts';
import { JwtInterceptor } from '../core/interceptor/jwt.interceptor';
import { ErrorInterceptor } from '../core/interceptor/error.interceptor';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { DataTablePagerComponent } from './components/ngx-datatable-pager.component';
import { NgxCommonFooterComponent } from './components/ngx-common-footer/ngx-common-footer.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SelectTextOnFocusDirective } from "./directives/select-text-on-focus.directive";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTableModule } from '@angular/material/table'
import { BackConfirmationComponent } from './components/back-confirmation/back-confirmation.component';
import { ServiceOrderFieldFilesComponent } from '../service-order/components/service-order-field-files/service-order-field-files.component';
import { COMMON_CONSTANTS } from "./constants/constant";
import { NewlineToBrPipe } from "./pipes/newline-to-br.pipe";
import { DashboardOrderEstimateSummaryComponent } from './components/dashboard-order-estimate-summary/dashboard-order-estimate-summary.component';
import { PlatinumInstructionsApplicableComponent } from '../job-labor-planning/component/platinum-instructions-applicable/platinum-instructions-applicable.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SoChatComponent } from './components/so-chat/so-chat.component';
import { MaterialsAddUpdateComponent } from './components/materials-add-update/materials-add-update.component';
import { MaterialsAddUpdateDialogComponent } from './components/materials-add-update/materials-add-update-dialog/materials-add-update-dialog.component';
import { EquipmentsAddUpdateComponent } from './components/equipment-add-update/equipments-add-update.component';
import { EquipmentsAddUpdateDialogComponent } from './components/equipment-add-update/equipments-add-update-dialog/equipments-add-update-dialog.component';
import { PhoneFormatPipe } from "./pipes/phone-format.pipe";
import metadata from 'libphonenumber-js/max/metadata';
import { tuiInputPhoneInternationalOptionsProvider } from '@taiga-ui/kit';
import { of } from "rxjs";

import { SmartComboNewComponent } from "./components/custom-combo-box-new/smart-combo-new.component";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NumericDirective } from './directives/numeric.directive';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

const icons = { Facebook, Twitter, Github, Gitlab, User, Key, UserCheck, Mail };
const SHARED_MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule, RouterModule,
  IconsModule,
  BootstrapModule, FormsModule,
  ReactiveFormsModule,
  FeatherModule.pick(icons),
  HttpClientModule, ALL_TAIGA_UI_MODULES,
  LoadingBarRouterModule, NgbModule,
  //ToastrModule.forRoot(),
  TranslateModule,
  FullCalendarModule,
  NgScrollbarModule,
  NgApexchartsModule,
  NgbProgressbarModule,
  NgxGaugeModule,
  ToastrModule.forRoot(
    {
      progressBar: true,
      closeButton: true,
      timeOut: COMMON_CONSTANTS.TOAST_TIME_MILLSECONDS_OUT,
      enableHtml: true,
    }
  ),
  NgSelectModule,
  NgxEchartsModule.forRoot({
    echarts: () => import('echarts'),
  }),
  SelectTextOnFocusDirective,
  DragDropModule,
  MatTableModule,
  NgbPopoverModule,
  ScrollingModule
];
@NgModule({
  declarations: [DataTablePagerComponent, NgxCommonFooterComponent, SpinnerComponent, BackConfirmationComponent, PlatinumInstructionsApplicableComponent, MaterialsAddUpdateComponent, MaterialsAddUpdateDialogComponent, EquipmentsAddUpdateComponent, EquipmentsAddUpdateDialogComponent,
    ServiceOrderFieldFilesComponent, DashboardOrderEstimateSummaryComponent, SoChatComponent, SmartComboNewComponent,NumericDirective
  ],
  imports: [
    SHARED_MODULES,
    NgxDatatableModule.forRoot({}),   // ← forRoot here, in imports only
    NewlineToBrPipe,
    PhoneFormatPipe
  ],
  exports: [
    SHARED_MODULES,
    NumericDirective,
      NgxDatatableModule,             // ← re-export plain (NOT forRoot) so feature modules get the directives
      DataTablePagerComponent, NgxCommonFooterComponent, SpinnerComponent, BackConfirmationComponent, MaterialsAddUpdateComponent, MaterialsAddUpdateDialogComponent, EquipmentsAddUpdateComponent, EquipmentsAddUpdateDialogComponent, PlatinumInstructionsApplicableComponent, ServiceOrderFieldFilesComponent, NewlineToBrPipe, DashboardOrderEstimateSummaryComponent, SoChatComponent, PhoneFormatPipe, SmartComboNewComponent],
  providers: [
    tuiInputPhoneInternationalOptionsProvider({
      metadata: of(metadata),
    }),
   
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
})
export class SharedModule { }



